module.exports = __webpack_public_path__ + "en.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/en.png
// module id = 1063
// module chunks = 0